/**
 * Registration Generic View
 */

define(function(require) {
    var _ = require('underscore');
    var RegistrationView = require('portlets/registration/registration.view');
    var RegistrationStepView = require('portlets/registration/generic/registration.step.view');
    var suggestionMixin = require('portlets/registration/mixins/suggestion.mixin');
    var limitsMixin = require('portlets/registration/mixins/limits.mixin');
    var dateMixin = require('portlets/registration/mixins/date.mixin');

    return RegistrationView.extend({

        mixinsMap: {
            userName: [suggestionMixin],
            depositLimits: [limitsMixin],
            betLimits: [limitsMixin],
            lossLimits: [limitsMixin],
            dateOfBirth: [dateMixin]
        },

        /**
         * @override
         */
        initialize: function(options) { // eslint-disable-line
            RegistrationView.prototype.initialize.apply(this, arguments);

            const activeForm = this.model.get('config').genericSteps;

            if (!activeForm) {
                throw new Error('Registration form is not selected');
            }

            const steps = activeForm.map(this._getStep, this);

            this.addSteps(steps);
        },

        _getMixins: function(fields) {
            return _.chain(this.mixinsMap).pick(_.pluck(fields, 'type')).values().flatten().value();
        },

        /**
         * Get registration step
         * @param  {Object} fields configuration with fields
         * @return {RegistrationStepView}
         */
        _getStep: function(fields) {
            var Step = RegistrationStepView.extend({
                mixins: this._getMixins(fields)
            });

            return new Step({
                template: 'registration.generic.step',
                model: this.model,
                config: {
                    genericFields: fields
                }
            });
        },

        filterFormDataOnSend: async function(formData) {
            if (formData.userName) {
                formData.userName = formData.userName.trim();
            }

            if (formData.iban) {
                formData.iban = formData.countrycode + formData.iban;
            }

            const { dataMap } = await Playtech.API.auth.getBeforeRegistrationHandler({ dataMap: formData });

            return dataMap;
        }
    });
});
